import React from 'react'

const PL7 = (props) => {
    console.log(props)
    let tapBeers = props.tapMenu.sections[0].items
    let canBeers = props.canMenu.sections[0].items

    if (tapBeers.length < 21){
        
        return (
            <div className="taps-can-page-multi">
                <div className="background-image">
                    <div className="col-left">
                        <div className="column pl7-taps-cans-pg-left">
                            {tapBeers.map(item => (
                            <div className="pl7-tap-item-page tap-item-print">
                                    {props.filterItem(item.name)} • {props.filterBrewery(item.brewery)} • $<span className="price-tap-print">{parseInt(item.containers[0].price)}</span>
                                    <div className="print-item-line-two pl7">{item.containers[0].name} • <span className="style-print pl7"> {props.filterStyle(item.style)}</span> • ABV {props.refactorAbv(item.abv)}% </div>
                            </div>
                            ))}
                        </div>
                    </div>
                    <div className="col-right">
                        <div className="column pl7-taps-cans-pg-right">
                            {canBeers.map(item => (
                            <div className="pl7-can-item-page tap-item-print">
                                    {props.filterItem(item.name)} • {props.filterBrewery(item.brewery)} • $<span className="price-tap-print">{parseInt(item.containers[0].price)}</span>
                                    <div className="print-item-line-two pl7 cans">{item.containers[0].name} • <span className="style-print-can pl7"> {props.filterStyle(item.style)}</span> • ABV {props.refactorAbv(item.abv)}% </div>
                            </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        )
    } else if (tapBeers.length > 21) {

        let leftTaps = tapBeers.slice(0, 19)
        let rightTaps = tapBeers.slice(19)

        console.log(leftTaps)
        console.log(rightTaps)

        return (
            <div className="taps-can-page-multi">
                <div className="background-image">
                    <div className="col-left">
                        <div className="column pl7-taps-cans-pg-left">
                            {leftTaps.map(item => (
                            <div className="pl7-tap-item-page tap-item-print">
                                    {props.filterItem(item.name)} • {props.filterBrewery(item.brewery)} • $<span className="price-tap-print">{parseInt(item.containers[0].price)}</span>
                                    <div className="print-item-line-two pl7">{item.containers[0].name} • <span className="style-print pl7"> {props.filterStyle(item.style)}</span> • ABV {props.refactorAbv(item.abv)}% </div>
                            </div>
                            ))}
                        </div>
                    </div>
                    <div className="col-right">
                        
                        <div className="column pl7-taps-cans-pg-right cans-row-1">
                            {rightTaps.map(item => (
                                <div className="pl7-can-item-page tap-item-print row1">
                                    {props.filterItem(item.name)} • {props.filterBrewery(item.brewery)} • $<span className="price-tap-print">{parseInt(item.containers[0].price)}</span>
                                        <div className="print-item-line-two pl7 cans">{item.containers[0].name} • <span className="style-print-can row1 pl7"> {props.filterStyle(item.style)}</span> • ABV {props.refactorAbv(item.abv)}% </div>
                                </div>
                            ))}
                        </div>
                        
                        <div className="column pl7-taps-cans-pg-right cans-row-2">
                            {canBeers.map(item => (
                                <div className="pl7-can-item-page tap-item-print row2">
                                        {props.filterItem(item.name)} • {props.filterBrewery(item.brewery)} • $<span className="price-tap-print">{parseInt(item.containers[0].price)}</span>
                                        <div className="print-item-line-two pl7 cans">{item.containers[0].name} • <span className="style-print-can row2 pl7"> {props.filterStyle(item.style)}</span> • ABV {props.refactorAbv(item.abv)}% </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

/* 
    Need dynamic layout that changes background image based on the number of taps



*/

export default PL7